import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegistrationHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-4">
      {/* Logo */}
      <div className="flex items-center justify-center space-x-3">
        <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center">
          <Icon name="Zap" size={24} color="white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-foreground">
            Selenium Sandbox
          </h1>
          <p className="text-sm text-muted-foreground">
            Interactive Automation Learning
          </p>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-foreground">
          Create Your Account
        </h2>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Join our community of developers and start mastering Selenium automation 
          with hands-on practice and real-time feedback.
        </p>
      </div>

      {/* Quick Stats */}
      <div className="flex items-center justify-center space-x-6 py-2">
        <div className="text-center">
          <div className="text-lg font-semibold text-primary">15K+</div>
          <div className="text-xs text-muted-foreground">Active Learners</div>
        </div>
        <div className="w-px h-8 bg-border"></div>
        <div className="text-center">
          <div className="text-lg font-semibold text-primary">50+</div>
          <div className="text-xs text-muted-foreground">Practice Missions</div>
        </div>
        <div className="w-px h-8 bg-border"></div>
        <div className="text-center">
          <div className="text-lg font-semibold text-primary">4.8★</div>
          <div className="text-xs text-muted-foreground">User Rating</div>
        </div>
      </div>

      {/* Alternative Login Option */}
      <div className="flex items-center justify-center space-x-2 text-sm">
        <span className="text-muted-foreground">Already have an account?</span>
        <Button
          variant="link"
          size="sm"
          onClick={() => navigate('/user-login')}
          className="p-0 h-auto text-primary hover:underline"
        >
          Sign in instead
        </Button>
      </div>
    </div>
  );
};

export default RegistrationHeader;